import GraphNavPanel from "./GraphNavPanel";
export default GraphNavPanel;
// Equal statement
// export { default } from "./GraphNavPanel";
